import superagent from 'superagent'

// export const fetchGetFilterCount = (payload) => (dispatch, getState, token) => {
//   Object.keys(payload).forEach((key) => {
//     if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
//       delete payload[key];
//     }
//   });

//   const params = new URLSearchParams(payload).toString();
//   return new Promise((resolve, reject) => {
//     superagent
//       .get(`${__API_URI__}/HuntPlanner/GetFilterCount?${params}`)
//       .set('Content-Type', 'application/json')
//       .set('Authorization', `Bearer ${token}`)
//       .set('Platform', 'Web')
//       .set('Version', `${__version__}`)
//       .end((err, res) => {
//         if (res) {
//           resolve(res.body)
//         } else if (err) {
//           reject(err)
//         }
//       })
//   })
// }

// DEDUPLICATION CONFIG
const DEDUPLICATION_WINDOW = 2000; // 3 seconds
const valueRequestCache = new Map();
const countRequestCache = new Map();
const stateExtentRequestCache = new Map();

const cleanPayload = (payload) => {
  const cleaned = { ...payload };
  Object.keys(cleaned).forEach((key) => {
    if (cleaned[key] === undefined || cleaned[key] === null || cleaned[key] === '') {
      delete cleaned[key];
    }
  });
  return cleaned;
};

// ====== fetchGetFilterValues ======
export const fetchGetFilterValues = (payload) => (dispatch, getState, token) => {
  const cleanedPayload = cleanPayload(payload);
  const params = new URLSearchParams(cleanedPayload).toString();
  const cacheKey = params;
  const now = Date.now();
  const existing = valueRequestCache.get(cacheKey);

  if (existing && now - existing.timestamp < DEDUPLICATION_WINDOW) {
    return existing.promise;
  }

  const request = new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/HuntPlanner/GetFilterValues?${params}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        valueRequestCache.delete(cacheKey);
        if (res) resolve(res.body);
        else reject(err);
      });
  });

  valueRequestCache.set(cacheKey, { timestamp: now, promise: request });
  return request;
};

// ====== fetchGetFilterCount ======
export const fetchGetFilterCount = (payload) => (dispatch, getState, token) => {
  const cleanedPayload = cleanPayload(payload);
  const params = new URLSearchParams(cleanedPayload).toString();
  const cacheKey = params;
  const now = Date.now();
  const existing = countRequestCache.get(cacheKey);

  if (existing && now - existing.timestamp < DEDUPLICATION_WINDOW) {
    return existing.promise;
  }

  const request = new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/HuntPlanner/GetFilterCount?${params}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        countRequestCache.delete(cacheKey);
        if (res) resolve(res.body);
        else reject(err);
      });
  });

  countRequestCache.set(cacheKey, { timestamp: now, promise: request });
  return request;
};


export const fetchGetStateGetExtent = (payload, stateAbbreviation) => (dispatch, getState, token) => {
  Object.keys(payload).forEach((key) => {
    if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
      delete payload[key];
    }
  });
  const cacheKey = params;
  const now = Date.now();
  const existing = stateExtentRequestCache.get(cacheKey);

  if (existing && now - existing.timestamp < DEDUPLICATION_WINDOW) {
    return existing.promise;
  }

  const params = new URLSearchParams(payload).toString();
  const request = new Promise((resolve, reject) => {
    // return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/State/GetExtent/${stateAbbreviation}?${params}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (res) {
          resolve(res.body)
        } else if (err) {
          reject(err)
        }
      })
  })
  stateExtentRequestCache.set(cacheKey, { timestamp: now, promise: request });
  return request;
}


// export const fetchGetFilterValues = (payload) => (dispatch, getState, token) => {
//   Object.keys(payload).forEach((key) => {
//     if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
//       delete payload[key];
//     }
//   });

//   const params = new URLSearchParams(payload).toString();
//   return new Promise((resolve, reject) => {
//     superagent
//       .get(`${__API_URI__}/HuntPlanner/GetFilterValues?${params}`)
//       .set('Content-Type', 'application/json')
//       .set('Authorization', `Bearer ${token}`)
//       .set('Platform', 'Web')
//       .set('Version', `${__version__}`)
//       .end((err, res) => {
//         if (res) {
//           resolve(res.body)
//         } else if (err) {
//           reject(err)
//         }
//       })
//   })
// }












export const fetchGetHuntUnitList = (payload) => (dispatch, getState, token) => {
  Object.keys(payload).forEach((key) => {
    if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
      delete payload[key];
    }
  });

  const params = new URLSearchParams(payload).toString();
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/HuntPlanner/GetHuntUnitList?${params}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (res) {
          resolve(res.body)
        } else if (err) {
          reject(err)
        }
      })
  })
}


export const fetchGetHuntList = (payload) => (dispatch, getState, token) => {
  Object.keys(payload).forEach((key) => {
    if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
      delete payload[key];
    }
  });

  const params = new URLSearchParams(payload).toString();
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/HuntPlanner/GetHuntList?${params}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (res) {
          resolve(res.body)
        } else if (err) {
          reject(err)
        }
      })
  })
}
